const breakpoints = {
    sm: "40em", // 640
    md: "52em", // 832
    lg: "64em", // 1024
    menu: "75em", // 1200
    xl: "75em", // 1200
    xxl: "80em", // 1280
}

export default breakpoints
